import React from 'react';
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
} from '@ant-design/icons';
import { Avatar, Button, Flex, Layout, Dropdown, Space } from 'antd';
import PageRoutes from "../PageRoutes";
import AppMenu from "../menu/index";

const { Header, Sider, Content } = Layout;

const DesktopLayout = ({ viewModel }) => {
  const {
    collapsed,
    toggleCollapsed,
    user,
    colorBgContainer,
    borderRadiusLG,
    accountMenu,
  } = viewModel;

  return (
    <Layout>
      <Sider trigger={null} collapsible collapsed={collapsed}>
        <div className="demo-logo-vertical" />
        <AppMenu variant="desktop"></AppMenu>
      </Sider>
      <Layout>
        <Header style={{ padding: 0, background: colorBgContainer }}>
          <Flex>
            <Space>
              <Button
                type="text"
                icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                onClick={toggleCollapsed}
                style={{
                  fontSize: '16px',
                  width: 64,
                  height: 64,
                }}
              />
              {user.work_space.name}
            </Space>

            <div style={{ flexGrow: 1, justifyContent: "center", flexDirection: "row", display: "flex", paddingRight: 16 }}>
              <Flex justify='flex-end' style={{ width: "100%" }}>
                <div style={{ justifyContent: "center", flexDirection: "column", display: "flex", paddingRight: 16 }}>
                  <Dropdown menu={accountMenu}>
                    <Avatar>{user.first_name}</Avatar>
                  </Dropdown>
                </div>
              </Flex>
            </div>
          </Flex>
        </Header>
        <Content
          style={{
            margin: '24px 16px',
            padding: 24,
            minHeight: '100vh',
            background: colorBgContainer,
            borderRadius: borderRadiusLG,
          }}
        >
          <PageRoutes></PageRoutes>
        </Content>
      </Layout>
    </Layout>
  );
};

export default DesktopLayout;
